import { Directive, OnDestroy, OnInit, TemplateRef, inject, input } from '@angular/core';
import { ToastService } from '../../../services/toast.service';

/**
 * Registers a custom body for toasts raised with a matching `key`, replacing
 * PrimeNG's `<p-toast key="…"><ng-template pTemplate="message">`.
 *
 *   <ng-template appToastTemplate="deployment-update" let-message>…</ng-template>
 *
 * The template is rendered inside the standard toast card, with the message as
 * the implicit context (`let-message`), so existing markup carries over as-is.
 */
@Directive({
  selector: '[appToastTemplate]',
  standalone: true,
})
export class ToastTemplateDirective implements OnInit, OnDestroy {
  readonly appToastTemplate = input.required<string>();

  private readonly templateRef = inject<TemplateRef<unknown>>(TemplateRef);
  private readonly toastService = inject(ToastService);

  ngOnInit(): void {
    this.toastService.registerTemplate(this.appToastTemplate(), this.templateRef);
  }

  ngOnDestroy(): void {
    this.toastService.unregisterTemplate(this.appToastTemplate(), this.templateRef);
  }
}
